import { translator } from 'core/localization';
import { AntSelectOption } from 'controls/react/ant/ant-select/types';

const i18n = translator({
	Scrollable: {
		no: 'Skroll',
	},
	Scale: {
		no: 'Skaler',
	},
	Responsive: {
		no: 'Responsiv',
	},
});

export enum LayoutType {
	Scroll = 'scroll',
	Adaptive = 'adaptive',
	Scale = 'scale',
}

let layoutTypeDataSource: AntSelectOption[];
export function getLayoutTypeDataSource() {
	if (layoutTypeDataSource == null) {
		layoutTypeDataSource = [
			{
				value: LayoutType.Scroll,
				label: i18n('Scrollable'),
			},
			{
				value: LayoutType.Scale,
				label: i18n('Scale'),
			},
			{
				value: LayoutType.Adaptive,
				label: i18n('Responsive'),
			},
		];
	}
	return layoutTypeDataSource;
}
